export default __webpack_public_path__ + "static/media/Despoiler's Tunic of Ushering Twilight.ca45c8df.jpg";